import { useCmsHashState } from '../../../../../../hooks/useHashState';

export type ProductDetailsSectionOffersPlAsideModalState = {
  offersPanelProductId: string;
};

/**
 * Open/close state of the PL Offers details panel, kept in the URL hash like
 * the reward and Google Reviews drawers (SSR-safe, client-only). Keyed by
 * product so a page with several products opens the right one.
 *
 * The panel also opens inside the PDP drawer (ProductDetails in MODAL mode,
 * CMS-2023 Q1: modal-in-modal), whose open state is the reward-modal hash keys,
 * so writes keep the other keys instead of rebuilding the hash.
 */
export const useOpenProductDetailsSectionOffersPlAsideModal = (
  productId?: string,
) => {
  const [hashState, setHashState] =
    useCmsHashState<ProductDetailsSectionOffersPlAsideModalState>(
      { offersPanelProductId: 'string' },
      { preserveOtherKeys: true },
    );

  return {
    isOpen: !!productId && hashState.offersPanelProductId === productId,
    open: () => {
      if (productId) setHashState({ offersPanelProductId: productId });
    },
    close: () => setHashState({ offersPanelProductId: undefined }),
  };
};
